import * as t from "./types";
import * as actions from "./action";

/* Account */
export const getAccountsAction = (
  payload: t.GetAccountsRequestType
): t.GetAccountsActionType => {
  return {
    type: actions.GET_ACCOUNTS,
    payload,
  };
};

export const getAccountAction = (
  payload: t.GetAccountRequestType
): t.GetAccountActionType => {
  return {
    type: actions.GET_ACCOUNT,
    payload,
  };
};

export const getCurrentUserAccountOwnerAction = (
  payload: t.GetCurrentUserAccountOwnerRequestType
): t.GetCurrentUserAccountOwnerActionType => {
  return {
    type: actions.GET_CURRENT_USER_ACCOUNT_OWNER,
    payload,
  };
};

export const addAccountAction = (
  payload: t.CreateAccountRequestType
): t.AddAccountActionType => {
  return {
    type: actions.ADD_ACCOUNT,
    payload,
  };
};

export const modifyAccountAction = (
  payload: t.ModifyAccountRequestType
): t.ModifyAccountActionType => {
  return {
    type: actions.MODIFY_ACCOUNT,
    payload,
  };
};

export const deleteAccountAction = (
  payload: t.DeleteAccountRequestType
): t.DeleteAccountActionType => {
  return {
    type: actions.DELETE_ACCOUNT,
    payload,
  };
};
